import axios from 'axios'

/**
 * @desc fetch list of all Agency consents
 */
export const fetchAgencyConsents = () =>
  axios.get('/authenticated/agency/consent').then((res) => res.data)

/**
 * @desc accept Agency consent
 * @param {Integer} consentId
 */
export const acceptAgencyConsent = (consentId) =>
  axios
    .put(`/authenticated/agency/consent?consentId=${consentId}`)
    .then((res) => res.data)

/**
 * @desc cancel Agency consent
 * @param {Integer} consentId
 */
export const cancelAgencyConsent = (consentId) =>
  axios
    .delete(`/authenticated/agency/consent?consentId=${consentId}`)
    .then((res) => res.data)

/**
 * @desc create Agency consent
 * @param {Array} storeIds
 */
export const createAgencyConsent = (storeIds) =>
  axios
    .post('/authenticated/agency/consent', { storeIds })
    .then((res) => res.data)

/**
 * @desc fetch list of all Retailers available for Consent
 */
export const fetchRetailersForConsent = () =>
  axios.get('/authenticated/agency/consent/stores').then((res) => res.data)
